export const locale = {
  lang: 'fr',
  data: {
    projectionEvent: {
      ResidenceRegisteredEvent: 'Le changement d\'adresse a été effectué avec succès.',
      ResidenceInformationCorrectedEvent: 'L\'adresse a été corrigée avec succès.',
      ResidenceCancelledEvent: 'Le changement d\'adresse a été annulée avec succès.',
      ResidenceDateCorrectedEvent: 'La date a été corrigée avec succès.',
      ResidenceDefinedAsProfessionalDomicileEvent: 'La résidence a été définie comme lieu d\'exercice principal',
      MunicipalityRegisteredEvent: 'La municipalité a été enregistrée',
      WorkAddressDefinedAsProfessionalDomicileEvent: 'Le lieu d\'exercice a été défini comme lieu d\'exercice principal',
      SecondaryWorkAddressRegisteredEvent: 'Lieu d\'exercice secondaire enregistré',
      SecondaryWorkAddressRemovedEvent: 'Lieu d\'exercice retiré',
      WorkAddressInformationCorrectedEvent: 'Lieu d\'exercice corrigé',
      WorkAddressEndDateCorrectedEvent: 'Correction de la date de fin enregistrée',
      WorkAddressEndDateCancelledEvent: 'Annulation de la date de fin enregistrée',
      WorkAddressStartDateCorrectedEvent: 'Correction de la date de début enregistrée',
      ProfessionalDomicileCancelledEvent: 'L\'assignation comme lieu d\'exercice principal a été anullée',
      SecondaryWorkAddressCancelledEvent: 'Lieu d\'exercice a été anullé',
      CorrespondenceTypeAssignedEvent: 'Le changement de correspondance a été ajouté avec succès',
      CorrespondenceTypeCancelledEvent: 'Le changement de correspondance a été annulé avec succès',
      CorrespondenceTypeDateCorrectedEvent: 'Le date du changement de correspondance a été modifiée avec succès',
      MemberPaymentRegisteredEvent: 'Paiement enregistré',
      MemberBillRegisteredEvent: 'Facture enregistrée',
      MemberPaymentTransactionLogRegisteredEvent: 'Reçu créé',
      MemberAccountingBatchRegisteredEvent: 'Lot enregistré',
      AnnualRegistrationEvent: 'Inscription annuelle enregistrée',
      MemberRegistrationActivatedFailedEvent: "Erreur lors de l'activation de l'inscription",
      WorkAddressEndDateCancelledFailedEvent: "Erreur lors de l'annulation de la date de fin du lieu d'exercice",
      MemberInsuranceAddedEvent: 'Assurance enregistrée'
    },
  },
};
